import { LinkNav } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { EPWORTH_LEVEL } from '../../../../../const/quiz'
import PortalLink from '../../../../shared/portal/PortalLinks/PortalLink'
import PortalMailingListSignup from '../../../../shared/portal/PortalMailingListSignup'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const RETURN_TO_DASHBOARD_LINK_LABEL = `Return to dashboard`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const actionForLevel = (link, level) => {
  if (level === EPWORTH_LEVEL.POSITIVE) {
    return <PortalLink link={link} dataCy="portal-link" />
  }

  return <PortalMailingListSignup dataCy="mailing-list-signup" />
}

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: [LAYOUT_SPACING.X_LARGE, 2],
  align: LAYOUT_ALIGN.CENTER,
})``

const Footer = styled.div`
  align-self: center;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Action = ({ link, level, dashboardUrl }) => (
  <Layout>
    {actionForLevel(link, level)}
    <Footer>
      <LinkNav href={dashboardUrl}>{RETURN_TO_DASHBOARD_LINK_LABEL}</LinkNav>
    </Footer>
  </Layout>
)

Action.propTypes = {
  level: PropTypes.string.isRequired,
  link: PropTypes.object.isRequired,
  dashboardUrl: PropTypes.string.isRequired,
}

export default Action
